<template>
  <div v-if="comment.visibility">
    <div
      v-if="
        !isOrganization ||
        comment.visibility ==
          'label_evaluation_requirementEvaluation_post_visibleToOrganization'
      "
    >
      <div class="commentContext">
        <span v-if="isReply">#{{ index + 1 }} - </span>
        <span v-if="comment.account && comment.account.account"
          >{{ comment.account.account.name }}
          {{ comment.account.account.lastName }}</span
        >
        -
        <span v-if="comment.category || parentComment.category"
          >{{ $t(comment.category || parentComment.category) }}
        </span>
        -
        <span v-if="comment.visibility || parentComment.visibility"
          >{{ $t(comment.visibility || parentComment.visibility) }}
        </span>
        -
        <span v-if="comment.scope || parentComment.scope"
          >{{ $t(comment.scope || parentComment.scope) }}
        </span>
        -
        <span v-if="comment.date || parentComment.date"
          >({{ comment.date || parentComment.date }}):
        </span>
      </div>
      <div class="commentText">
        {{ comment.comment || comment.content }}
        <span v-if="canEdit" style="cursor: pointer" @click="setEdit()"
          ><img
            src="../../assets/images/edit_icon.svg"
            style="width: 20px; height: 20px"
        /></span>
        <span v-if="canEdit && !isReply" style="cursor: pointer" @click="newReply"
          ><img
            src="../../assets/images/comment_icon.svg"
            class="filter-green"
            style="width: 20px; height: 20px"
        /></span>
        <span v-if="!canEdit">
          <b-button
            size="sm"
            variant="link"
            class="mr-1"
            @click="openDeleteModal(index)"
          >
            <!--<img src="../../assets/images/delete_icon.svg" style="    width: 20px;    height: 20px;" >-->
          </b-button>
        </span>
        <template v-if="!parentComment">
          <div
            v-for="(rep, replyIndex) of comment.replies"
            :key="replyIndex"
            style="padding-left: 40px; margin-top: 5px"
          >
            <template-evaluation-comment
              :comment="rep"
              :can-edit="canEdit"
              :parent-comment="comment"
              :is-reply="true"
              :parent-comment-index="index"
              :index="replyIndex"
              @setEdit="setEditReply"
              :is-organization="isOrganization"
            ></template-evaluation-comment>
          </div>
        </template>
        <div v-if="isRepliying" style="padding-left: 50px">
          <b-container style="text-align: left">
            <b-form-group
              id="reply"
              :label="$t('label_evaluation_requirementEvaluation_replies')"
              label-for="comment"
            >
              <b-input-group>
                <b-textarea id="comment" v-model="reply.content" />
              </b-input-group>
            </b-form-group>
          </b-container>
          <div class="text-right">
            <b-button
              variant="primary"
              style="margin-right: 15px; margin-bottom: -15px"
              @click="postReply()"
            >
              {{ $t("label_evaluation_requirementEvaluation_post_button") }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TemplateEvaluationComment",
  props: {
    comment: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: null,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    isOrganization: {
      type: Boolean,
      default: false,
    },
    isReply: {
      type: Boolean,
      default: false,
    },
    parentComment: {
      type: Object,
      default: () => {},
    },
    parentCommentIndex: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isRepliying: false,
      reply: {},
    };
  },

  methods: {
    setEdit() {
      this.$emit("setEdit", {
        index: this.index,
        isReply: this.isReply,
        parentIndex: this.parentCommentIndex,
      });
    },
    setEditReply(editParams) {
      console.log(editParams);
      this.$emit("setEdit", editParams);
    },
    newReply() {
      this.$emit("setEdit", {
        index: -1,
        isReply: true,
        parentIndex: this.index,
      });
    },
    openDeleteModal(index) {
      this.$emit("openDeleteModal", index);
    },
    async postReply() {
      let valuesToPush = {};
      let baseCommentPath = `comments.${this.index}.replies`;

      valuesToPush[`${baseCommentPath}`] = {
        date: new Date().toLocaleDateString("en-US"),
        account: { account: this.getUserAccount },
        id: 1 + ((this.comment.replies && this.comment.replies.length) || 0),
        content: this.reply.content,
      };

      await this.$store.dispatch("updateEvaluation", { valuesToPush });

      this.isRepliying = false;
      this.reply = {};
    },
  },
  computed: {
    ...mapGetters(["getUserAccount"]),
  },
};
</script>

<style lang="scss" >
/* components/template/_template-evaluation-comment */

.filter-green{
    filter: invert(18%) sepia(80%) saturate(1377%) hue-rotate(199deg) brightness(95%) contrast(90%);
}
</style>
